var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Graph/Service Account") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Graph/Service-Account",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#658BD3",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uF084",
    transform: "translate(10.415737, 10.209263)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.71914029,9.39804721 L6.78398454,10.2839845 C6.68554688,10.4316406 6.51874983,10.5 6.34375,10.5 L5.25,10.5 L5.25,11.59375 C5.25,11.9574215 4.95742196,12.25 4.59375,12.25 L3.5,12.25 L3.5,13.34375 C3.5,13.7074215 3.20742196,14 2.84375,14 L0.65625,14 C0.293945312,14 0,13.7074215 0,13.34375 L0,11.15625 C0,10.9812502 0.069152534,10.8144531 0.192199409,10.6914062 L4.60195321,6.28085929 C4.45429671,5.81875008 4.375,5.32382804 4.375,4.8125 C4.375,2.15468717 6.52968758,0 9.1875,0 C11.8453128,0 14,2.15468717 14,4.8125 C14,7.47031283 11.8453128,9.625 9.1875,9.625 C8.67617154,9.625 8.18125033,9.54570329 7.71914029,9.39804721 Z M10.28125,4.8125 C10.885547,4.8125 11.375,4.32304704 11.375,3.71875 C11.375,3.11445296 10.885547,2.625 10.28125,2.625 C9.67695296,2.625 9.1875,3.11445296 9.1875,3.71875 C9.1875,4.32304704 9.67695296,4.8125 10.28125,4.8125 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceAccount);
export default __webpack_public_path__ + "static/media/ServiceAccount.416c411fe83b58ff4ea48618ac4b216d.svg";
export { ForwardRef as ReactComponent };